import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import About from './views/About.vue';
import Service from './views/Service.vue';
import Product from './views/Product.vue';
import Support from './views/Support.vue';
import PeptideCalculator from './views/PeptideCalculator.vue';
import PeptideContentCalculator from './views/PeptideContentCalculator.vue';
import Order from './views/Order.vue';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Router);
Vue.use(ElementUI)

export default new Router({
  mode: 'hash',
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/about', name: 'About', component: About },
    { path: '/service', name: 'Service', component: Service },
    { path: '/product', name: 'Product', component: Product },
    { path: '/support', name: 'Support', component: Support },
    { path: '/support/calculator', name: 'PeptideCalculator', component: PeptideCalculator },
    { path: '/support/content-calculator', name: 'PeptideContentCalculator', component: PeptideContentCalculator },
    { path: '/order', name: 'Order', component: Order }
  ]
}); 